import moment from "moment";
import { DATE_FORMAT } from "src/config";
const parseDate = (arg, inputFormat = "YYYY-MM-DD") => {
  const date = arg?.split("T")[0];
  return date ? moment(date, inputFormat).format(DATE_FORMAT) : "-";
};
export default parseDate;
